<ng-template #PropertyProtectionPolicy>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{propertyProtectionLabel}} - Proof of Insurance</h5>
            <button type="button" class="close pull-right" aria-label="Close" (click)="ClosePOIPopUp()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body common_form">
            <div class="row">
                <div class="col-md-6 col-sm-6">
                    <label>{{propertyProtectionLabel}} Policy#<span class="required">*</span></label>
                </div>
                <div class="col-md-6 col-sm-6">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="PolicyNumber" maxlength="25">
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-6 col-sm-6">
                    <label>{{propertyProtectionLabel}} Company Name<span class="required">*</span></label>
                </div>
                <div class="col-md-6 col-sm-6">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="InsCompanyName" maxlength="50">
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-6 col-sm-6">
                    <label>{{propertyProtectionLabel}} Expiry Date<span class="required">*</span></label>
                </div>
                <div class="col-md-6 col-sm-6">
                    <ejs-datepicker class="form-control p-0 h-auto" required name="date" [allowEdit]='false'
                        [(ngModel)]="ExpiryDate" format='MM/dd/yyyy' [max]='expEndDate'>
                    </ejs-datepicker>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary me-3" (click)="ClosePOIPopUp()">Cancel</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" [disabled]="disableSave()"
                (click)="saveProofOfInsurance()" i18n="@@Save">Save</button>
        </div>
    </div>
</ng-template>